import { h, Fragment } from "preact";
import ProductOptionSwatch from "./product-option-swatch";
import ProductOptionInlineHeader from "./product-option-inline-header";

export default function ProductOptionSwatchesInline({
  optionValues,
  optionName,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues = [],
  last,
}) {
  return (
    <div
      className={`product-options__option-inline ${last ? "product-options__option-inline--last" : ""} product-options__swatches-inline`}
    >
      <ProductOptionInlineHeader
        optionName={optionName}
        selectedOptionValue={selectedOptionValue}
      />
      <fieldset className="product-options__swatch-list-inline">
        <legend className="visually-hidden">{optionName}</legend>
        {optionValues.map((optionValue) => (
          <ProductOptionSwatch
            key={optionValue.name}
            optionValue={optionValue}
            optionName={optionName}
            disabled={disabledOptionValues.includes(optionValue.name)}
            updateOptionValue={updateOptionValue}
            selected={optionValue.name === selectedOptionValue}
          />
        ))}
      </fieldset>
    </div>
  );
}
